<template>
    <div class="container-fluid">
        <div class="titlle_div">
            <h5 class="title">Canales</h5>
        </div>
        <emt-form ref="channel-form" v-bind:resource="config.api + '/channel/'" v-bind:items="itemsForm" v-on:register="reload" v-bind:updateData="update"></emt-form>
        <emt-grid ref="channel-grid" v-bind:resource="config.api + '/channel/'" v-bind:items="itemsGrid" v-bind:edit="editUrl" v-bind:deleteUrl="deleteUrl"></emt-grid>
    </div>
</template>

<script>
import Cookies from 'js-cookie'
import router from '@/router'
import generic from '@/generic'
import Config from '@/config'
import EmtForm from '@/components/emt-form'
import EmtLoading from '@/components/emt-loading'
import EmtTable from '@/components/emt-grid'

export default{
    name: 'emt-form-channel',
    data: function () {
        return {
            itemsForm: [
                {
                    'name': 'name',
                    'label': 'Nombre canal',
                    'placeholder': 'Ingrese nombre de canal',
                    'value': null,
                    'maxlength': '50',
                    'type': 'text',
                    'errors': []
                }
            ],
            itemsGrid: [
                {
                    'name': 'name',
                    'label': 'Canal',
                    'ordering': true,
                    'filters': ['exact', {
                        'name': 'icontains',
                        'label': 'Puede contener'
                    }]
                }, {
                    'name': 'is_active',
                    'label': 'Estado',
                    'ordering': true
                }
            ],
            config: Config,
            update: false,
            editUrl: '/channel/',
            deleteUrl: Config.api + '/channel/'
        }
    },
    methods: {
        reload: function () {
            this.$refs['channel-grid'].reload()
        }
    },
    created: function () {
        if (!Cookies.get('token')) {
            router.push('/login')
            return
        }
        generic.setToken()
    },
    components: {
        'emt-form': EmtForm,
        'emt-loading': EmtLoading,
        'emt-grid': EmtTable
    }
}
</script>



// WEBPACK FOOTER //
// emt-form-channel.vue?3e07a35f